export const industryOptions = [
  {"name":"Accommodation and Food Services","id":"555bb0e425a9732ca20a3116"},
  {"name":"Administrative and Support services","id":"555bb0e425a9732ca20a3784"},
  {"name":"Agriculture, Forestry and Fishing","id":"555bb0e425a9732ca20a1000"},
  {"name":"Arts and Recreation Services","id":"555bb0e425a9732ca20a4151"},
  {"name":"Construction","id":"555bb0e425a9732ca20a2425"},
  {"name":"Education and Training","id":"555bb0e425a9732ca20a3933"},
  {"name":"Electricity, Gas, Water and Waste Services","id":"555bb0e425a9732ca20a2366"},
  {"name":"Financial and Insurance Services","id":"555bb0e425a9732ca20a3453"},
  {"name":"Health Care and Social Assistance","id":"555bb0e425a9732ca20a4009"},
  {"name":"Information Media and Telecommunication","id":"555bb0e425a9732ca20a3355"},
  {"name":"Manufacturing","id":"555bb0e425a9732ca20a1314"},
  {"name":"Mining","id":"555bb0e425a9732ca20a1244"},
  {"name":"Other Services","id":"555bb0e425a9732ca20a4360"},
  {"name":"Professional, Scientific and Technical Services","id":"555bb0e425a9732ca20a3634"},
  {"name":"Public Administration and Safety","id":"555bb0e425a9732ca20a3868"},
  {"name":"Rental, Hiring and Real Estate Services","id":"555bb0e425a9732ca20a3535"},
  {"name":"Retail Trade","id":"555bb0e425a9732ca20a2857"},
  {"name":"Transport, Postal and Warehousing","id":"555bb0e425a9732ca20a3166"},
  {"name":"Wholesale Trade","id":"555bb0e425a9732ca20a2607"}
];